import { type ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { useCurrentCaseContext } from "~/pages/Compliance/context/CurrentCaseContext";
import { useIsFatcaCrsEnabledForCase } from "~/pages/Compliance/flags";

export const WITHHOLDING_STATEMENT_SUBTYPE = "withholding_statement";

const W_SERIES_TAX_FORM_TYPES = {
  W_9: {
    value: "W-9",
    readableName: "W-9",
  },
  W_8BEN: {
    value: "W-8BEN",
    readableName: "W-8BEN",
  },
  W_8BEN_E: {
    value: "W-8BEN-E",
    readableName: "W-8BEN-E",
  },
  W_8ECI: {
    value: "W-8ECI",
    readableName: "W-8ECI",
  },
  W_8EXP: {
    value: "W-8EXP",
    readableName: "W-8EXP",
  },
  W_8IMY: {
    value: "W-8IMY",
    readableName: "W-8IMY",
  },
  WITHHOLDING_STATEMENT: {
    value: WITHHOLDING_STATEMENT_SUBTYPE,
    readableName: "Withholding Statement",
  },
};

// Convert the object to an array of entries
const baseWSeriesTaxFormTypesArray = Object.values(W_SERIES_TAX_FORM_TYPES);

export const useWSeriesTaxFormTypesArray = () => {
  const { caseType, fatcaCrsEnabled } = useCurrentCaseContext();
  const isFatcaCrsEnabled = useIsFatcaCrsEnabledForCase(
    caseType as ComplianceCaseTypeEnum | undefined,
    fatcaCrsEnabled,
  );

  if (isFatcaCrsEnabled) {
    return baseWSeriesTaxFormTypesArray;
  }

  // Filter out Withholding Statement if feature flag is disabled
  return baseWSeriesTaxFormTypesArray.filter((type) => type.value !== "withholding_statement");
};

export const wSeriesTaxFormTypesArray = baseWSeriesTaxFormTypesArray;
